
export const light = { 
    body: "#fff",
    text: "#202020",
    bodyRgba: "255, 255, 255",
    textRgba: "32, 32, 32",

    carouselColor: "#EEEDDE",
    fontxs: "0.7rem",
    fontsm: "0.875rem",
    fontmd: "1rem",
    fontlg: "1.25rem",
    fontbig: "1.8rem",
    fontxl: "2rem",
    fontxxl: "3rem",
    fontxxxl: "4rem",

    fontButton: "0.875rem",
    navHeight: "5rem",
    zIndexHeader: 100,
}

export const dark = { 
    body: "#202020",
    text: "#fff",
    bodyRgba: "32, 32, 32",
    textRgba: "255, 255, 255",

    carouselColor: "#EEEDDEE",
    fontxs: "0.7rem",
    fontsm: "0.875rem",
    fontmd: "1rem",
    fontlg: "1.25rem",
    fontbig: "1.8rem",
    fontxl: "2rem",
    fontxxl: "3rem",
    fontxxxl: "4rem",

    fontButton: "0.875rem",
    navHeight: "5rem",
    zIndexHeader: 100,
}